import { httpClient } from './http-client';

// Helper function to map menu items
const mapMenuItems = (data) => {
  return data.map((parent) => {
    return {
      title: parent.menu_name,
      path: '/page/' + parent.menu_id,
      ...parent,
      children: parent.children?.map((child) => ({
        title: child.menu_name,
        path: '/page/' + child.menu_id,
        ...child,
      })),
    };
  });
};

// Function to fetch menu items by page
export const getMenuItems = async (page = 0) => {
  try {
    const response = await httpClient.get('api/menu.php', {
      params: { id: page },
    });
    return mapMenuItems(response.data);
  } catch (error) {
    console.error('Error fetching menu items:', error);
    throw error; // Re-throw the error for the caller to handle
  }
};

// Function to fetch submenu items by page
export const getSubMenuItems = async (page) => {
  try {
    const response = await httpClient.get('api/menu_by_submenuId.php', {
      params: { id: page },
    });
    return mapMenuItems(response.data);
  } catch (error) {
    console.error('Error fetching submenu items:', error);
    throw error; // Re-throw the error for the caller to handle
  }
};
